import axios from "axios";
import { toast } from "react-toastify";
import history from "../config/history";
import { HOMEPAGE, OUTLET, REFRESHTOKEN } from "./constants";
import { getEncodedHeader } from "./utility";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL + "/api/v1",
  params: {
    booking_from: "iFrame",
  },
});

instance.interceptors.request.use((config) => {
  let configUrl = config.url.toString();

  let md5query = {
    deviceId: "",
    deviceType: "iFrame",
    currentTime: new Date().getTime(),
  };

  let randomNo = Math.floor(1000 + Math.random() * 100000000);
  if (
    localStorage.getItem("deviceId") === null ||
    localStorage.getItem("deviceId") === ""
  ) {
    localStorage.setItem("deviceId", randomNo);
  }
  md5query.deviceId = localStorage.getItem("deviceId");

  const queryString = new URLSearchParams(md5query).toString();

  config.url = `${config.url}?${queryString}`;
  config.headers = {
    "x-value": getEncodedHeader(
      config.data,
      { ...md5query, ...config.params },
      config.method
    ),
  };

  if (configUrl.indexOf(`${OUTLET}${HOMEPAGE}`) < 0) {
    const apiToken = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${apiToken}`;
  }
  config.headers["X-Requested-Source"] = `web`;

  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response?.status === 401) {
      // console.log("You are not authorized");
      // TOAST MESSAGE
    }
    if (response?.status >= 500) {
      toast.error("SERVER ERROR");
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASEURL}/api/v1${REFRESHTOKEN}`,
          { refreshToken }
        );
        const { accessToken, refreshToken: rToken } = response.data.data;

        localStorage.setItem("token", accessToken);
        localStorage.setItem("refreshToken", rToken);

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (error) {
        toast.error("Session expired, Please Re-login", {
          hideProgressBar: true,
        });
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("type");
        localStorage.removeItem("name");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("guestSigned");
        setTimeout(() => {
          history.replace("/lww/auth/login");
          window.location.reload();
        }, 2000);
      }
    }

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);

export const http = instance;
